module.exports = __webpack_public_path__ + "img/wakn.ee63970e.jpg";